<template>
  <div>
    <template v-if="!fileExists">
      <div class="no-exist-msg">
        Shared Results either does not exist, has expired, or is not ready yet. Please check when you have
        received the link.
      </div>
    </template>
    <template v-else>
      <div>
        <codemirror
          :value="query"
          :options="cmOptions"
          class="shared-query-cm"
        />
        <div class="mid-section-container">
          <div>
            <div>
              <b>Date of Result Creation: </b>{{ formattedSharedQueryCreated }}
            </div>
            <div>
              <b>Expires in: </b>{{ sharedQueryExpires }}
            </div>
          </div>
          <div class="copy-icon-container">
            <Tooltip
              content="Copy"
              placement="top"
              @click.native="copyQuery"
            >
              <i class="far fa-clone fa-2x" />
            </Tooltip>
          </div>
        </div>
        <Divider class="shared-table-divider" />
        <QueryTable
          :query="query"
          :query-name="queryName"
          :snowflake-config="snowflakeConfig"
          :shared-query-file-name="sharedQueryFileName"
          :is-loading="loading"
          :share-mode="true"
          :show-action="true"
          :results="sharedQueryResults"
        />
      </div>
    </template>
  </div>
</template>
<script>
import QueryTable from './QueryTable'
import axios from 'axios'
import _ from 'lodash'
import moment from 'moment-timezone'

export default {

  components: {
    QueryTable
  },

  props: {
    queryObj: Object,
    snowflakeConfig: Object,
    sharedQueryFileName: String
  },

  data () {
    return {
      query: '',
      queryName: (this.queryObj && this.queryObj.name) || '',
      cmOptions: {
        theme: 'default',
        tabSize: 4,
        indentUnit: 4,
        smartIndent: true,
        matchBrackets: true,
        closeBrackets: true,
        mode: { name: 'text/x-sql', globalVars: true },
        lineNumbers: true,
        autoRefresh: true,
        readOnly: 'nocursor'
      },
      fileExists: true,
      sharedQueryCreated: '',
      sharedQueryResults: [],
      loading: false
    }
  },

  computed: {
    formattedSharedQueryCreated () {
      return moment(this.sharedQueryCreated).tz(moment.tz.guess()).format('MMM-DD-YYYY HH:mm:ss z')
    },

    sharedQueryExpires () {
      if (!this.sharedQueryCreated) {
        return `N/A`
      }

      const createdTime = moment(this.sharedQueryCreated)
      const now = moment()

      return `${30 - now.diff(createdTime, 'days')} days`
    }
  },

  watch: {
    queryObj (newQueryObj) {
      this.queryName = newQueryObj.queryName
      this.loadSharedResults()
    }
  },

  created () {
    this.loadSharedResults()
    this.loadQuery()
  },

  methods: {
    /**
       * Loads the results of the shared query.
       */
    loadSharedResults () {
      if (!_.isEmpty(this.queryObj)) {
        this.loading = true
        // Make API Call to get CSV file
        axios.get(`${process.env.VUE_APP_API_URI}/query-pad/shared-query-result`, {
          params: {
            queryId: this.queryObj.id,
            fileName: this.sharedQueryFileName
          }
        }).then(result => {
          this.sharedQueryCreated = result.data.lastModified
          this.sharedQueryResults = result.data.table
          this.loading = false
        }, error => {
          console.error('Error is ', error)
          this.fileExists = false
          this.loading = false
        })
      }
    },

    /**
       * Loads the query based on history id
       */
    async loadQuery () {
      const fileNameSplit = this.sharedQueryFileName.split('-')

      if (fileNameSplit.length === 0) return

      try {
        const historyId = fileNameSplit[0]
        const query = await axios.get(`${process.env.VUE_APP_API_URI}/query-pad/query-history/${historyId}`)
        this.query = query.data[0].queryText
      } catch (err) {
        console.error(`Error while fetching query history: ${err}`)
      }
    },

    /**
       * Copies the Query onto Clipboard
       */
    copyQuery () {
      this.$copyText(this.query).then(
        this.onCopySuccess.bind(this),
        this.onCopyError.bind(this)
      )
    },

    /**
       * Runs when copying query succeeds
       */
    onCopySuccess () {
      this.$Message.success({
        content: 'Copied to clipboard!',
        duration: 3
      })
    },

    /**
       * Runs when copying query fails
       */
    onCopyError () {
      this.$Message.error({
        content: 'Error while copying to clipboard!',
        duration: 3
      })
    }
  }
}
</script>
<style scoped>
  .shared-query-cm {
    border: 1px solid;
  }
  .mid-section-container {
    margin: 16px 0px 16px;
    display: flex;
    justify-content: space-between;
  }
  .copy-icon-container {
    margin-right: 16px;
  }
  .no-exist-msg {
    text-align: center;
    font-size: 32px;
    margin-top: 15%;
    margin-bottom: 15%;
  }
</style>
